/* OrtoLogic: cinematic product previews synced to the page scroll. */
(function(){
 'use strict';
 var roots=Array.prototype.slice.call(document.querySelectorAll('.opc'));
 if(!roots.length||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
 var scenes=roots.map(function(root){
  return {root:root,cover:root.querySelector('.opc__cover'),a:root.querySelector('.opc__sheet--a'),b:root.querySelector('.opc__sheet--b'),steps:root.querySelectorAll('.opc__step'),p:-1};
 });
 var scheduled=false;
 function clamp(n){return Math.max(0,Math.min(1,n))}
 function ease(n){n=clamp(n);return n*n*(3-2*n)}
 function draw(){
  scheduled=false;
  var mobile=innerWidth<750;
  scenes.forEach(function(s){
   var rect=s.root.getBoundingClientRect();
   var length=Math.max(1,s.root.offsetHeight-innerHeight);
   var p=clamp(-rect.top/length);
   if(Math.abs(p-s.p)<.0005)return;
   s.p=p;
   s.root.style.setProperty('--opc-p',p.toFixed(4));
   var a=ease((p-.19)/.35);
   var b=ease((p-.44)/.34);
   var r=ease((p-.04)/.82);
   var amount=mobile?.65:1;
   var x=(-9+(-36*a+60*b))*amount;
   var y=(-7+19*a-7*b)*amount;
   var rotY=(-16+23*r)*amount;
   var rotZ=(-5+9*r)*amount;
   var scale=1-.22*a-.04*b;
   s.cover.style.transform='translate3d('+x.toFixed(2)+'%,'+y.toFixed(2)+'%,0) rotateY('+rotY.toFixed(2)+'deg) rotateZ('+rotZ.toFixed(2)+'deg) scale('+scale.toFixed(3)+')';
   s.a.style.opacity=a.toFixed(3);
   s.b.style.opacity=b.toFixed(3);
   s.a.style.transform='translate3d('+((-7+36*a)*amount).toFixed(1)+'%,'+(18-24*a).toFixed(1)+'%,0) rotateZ('+(-14+18*a).toFixed(1)+'deg) rotateY('+(13-20*a).toFixed(1)+'deg)';
   s.b.style.transform='translate3d('+((-8-47*b)*amount).toFixed(1)+'%,'+(23-27*b).toFixed(1)+'%,0) rotateZ('+(-7-8*b).toFixed(1)+'deg)';
   var at=p<.32?0:p<.65?1:2;
   s.steps.forEach(function(node,i){node.classList.toggle('is-active',at===i)});
  });
 }
 function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(draw)}}
 addEventListener('scroll',schedule,{passive:true});
 addEventListener('resize',schedule,{passive:true});
 document.addEventListener('shopify:section:load',schedule);
 schedule();
})();